import { createSupabaseForUniversal } from '@gv/core';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY!;

export const SUPABASE_URL = supabaseUrl;
export const SUPABASE_ANON_KEY = supabaseKey;

export const supabase = createSupabaseForUniversal({
    url: supabaseUrl,
    anonKey: supabaseKey,
    // Web uses default storage; keep URL detection for PKCE OAuth callback handling
    detectSessionInUrl: true,
});